import { Linking, Platform } from 'react-native-web';

const SUPPORT_PAGE_URL = 'https://styleseat.freshdesk.com/support/home';

/**
 * Module that manages our support service solution (used to be for ZenDesk).
 * currently only exposes the ability to open a support link
 */
class SupportServiceWrapper {
  // eslint-disable-next-line class-methods-use-this
  open() {
    if (Platform.OS === 'web') {
      window.open(SUPPORT_PAGE_URL, '_system');
    } else {
      Linking.openURL(SUPPORT_PAGE_URL);
    }
  }
}

export default new SupportServiceWrapper();
